var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgViewColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 3.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16666667,0 L8.33333333,0 C7.87333333,0 7.5,0.498888889 7.5,1.11111111 L7.5,8.88888889 C7.5,9.50166667 7.87333333,10 8.33333333,10 L9.16666667,10 C9.62666667,10 10,9.50166667 10,8.88888889 L10,1.11111111 C10,0.498888889 9.62666667,0 9.16666667,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41666667,0 L4.58333333,0 C4.12333333,0 3.75,0.498888889 3.75,1.11111111 L3.75,8.88888889 C3.75,9.50166667 4.12333333,10 4.58333333,10 L5.41666667,10 C5.87666667,10 6.25,9.50166667 6.25,8.88888889 L6.25,1.11111111 C6.25,0.498888889 5.87666667,0 5.41666667,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66666667,0 L0.833333333,0 C0.37375,0 0,0.498888889 0,1.11111111 L0,8.88888889 C0,9.50166667 0.37375,10 0.833333333,10 L1.66666667,10 C2.12625,10 2.5,9.50166667 2.5,8.88888889 L2.5,1.11111111 C2.5,0.498888889 2.12625,0 1.66666667,0 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewColumn);
export default __webpack_public_path__ + "static/media/view-column.8ea0e5292d5aaac130b4d183390b83bc.svg";
export { ForwardRef as ReactComponent };